import { useMemo } from 'react';
import { Route, Routes as ReactRouterRoutes } from 'react-router-dom';

import JobDetailsPage from 'hb-react/frontoffice/apps/JobsV2/pages/JobDetailsPage';
import JobsIndexPage from 'hb-react/frontoffice/apps/JobsV2/pages/JobsIndexPage';
import embeddedDetailsTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/EmbeddedDetailsTemplate';
import oneColumnTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/OneColumnTemplate';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import JobForm from 'hb-react/shared/apps/JobForm/startup/fo';

import { makeConfigUrls } from './utils';

const JobsV2App = ({
  configUrls: makeUrls = makeConfigUrls,
  configPage,
  topic,
  ...otherProps
}) => {
  const { currentUser } = useDefaultAppContexts();

  const urls = useMemo(
    () => makeUrls({ currentUser }),
    [currentUser, makeUrls],
  );

  const templateId =
    configPage?.config?.blocks_renderer_template || oneColumnTemplate.id;

  return (
    <ReactRouterRoutes>
      {currentUser && [
        <Route
          element={<JobForm configPage={configPage} mode="frontoffice" />}
          key="new"
          path="new"
        />,
        <Route
          element={<JobForm configPage={configPage} mode="frontoffice" />}
          key="edit"
          path="/:opportunityId/edit"
        />,
        <Route
          element={<JobForm configPage={configPage} mode="frontoffice" renew />}
          key="renew"
          path="/:opportunityId/renew"
        />,
      ]}
      {templateId !== embeddedDetailsTemplate.id && (
        <Route
          key="details"
          path="/:opportunityId"
          element={
            <JobDetailsPage configPage={configPage} topic={topic} urls={urls} />
          }
        />
      )}
      <Route path="/">
        <Route
          index
          element={
            <JobsIndexPage
              configPage={configPage}
              topic={topic}
              urls={urls}
              {...otherProps}
            />
          }
        />
        <Route
          path=":opportunityId"
          element={
            <JobsIndexPage
              configPage={configPage}
              urls={urls}
              topic={topic}
              {...otherProps}
            />
          }
        />
      </Route>
    </ReactRouterRoutes>
  );
};

export default JobsV2App;
